import { HashRouter as Router, Routes, Route } from "react-router-dom";
import AppRoutes from "./routes";
import React from "react";
import Navbar from "./components/Navbar"; // Always visible navbar
import "./App.css";

// import Services from "./pages/services/Services";
import ComprehensiveTherapeuticServices from "./pages/services/Comprehensive-Therapetic-Services";
import MedicalRehabilitation from './pages/services/medical-rehabilitation';
import OcationalRehabilation from "./pages/services/Ocational-Rehabilation";
import PsychiatricRehabilation from "./pages/services/Psychiatric-Rehabilation";
import SpecialSchool from "./pages/services/Special-School";
import PhysiotherapyServices from "./pages/services/Physiotherapy-Services";
import OccupationalTherapy from "./pages/services/Occupational-Therapy";
import SpeechTherpy from "./pages/services/Speech-Therpy";
import Psychology from "./pages/services/Psychology";

import ScrollToTop from "./components/ScrollToTop";
import Applynow from "./pages/Applynow";
// import ServicePopup from "./components/ServicePopup";




function App() {
  return (
    <Router>
      <Navbar />    {/* Navbar below alert */}
      <ScrollToTop/>
      {/* <ServicePopup/> */} {/* Uncomment to show service popup */}
      <Routes>
        {/* apply now route */}
        <Route path="/apply" element={<Applynow />} />
        {/* <Route path="/services" element={<Services />} /> */}
        <Route path="/services/Comprehensive-Therapetic-Services" element={<ComprehensiveTherapeuticServices />} />
        <Route path="/services/medical-rehabilitation" element={<MedicalRehabilitation />} />
        <Route path="/services/Ocational-Rehabilation" element={<OcationalRehabilation />} />
        <Route path="/services/Psychiatric-Rehabilation" element={<PsychiatricRehabilation />} />
        <Route path="/services/Special-School" element={<SpecialSchool />} />
        <Route path="/services/Physiotherapy-Services" element={<PhysiotherapyServices />} />
        <Route path="/services/Occupational-Therapy" element={<OccupationalTherapy />} />
        <Route path="/services/Speech-Therpy" element={<SpeechTherpy />} />
        <Route path="/services/Psychology" element={<Psychology />} />
      </Routes>
      <AppRoutes />
    </Router>
  );
}

export default App;